"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubCategoriesFilterBar = void 0;
require("../css/subcategories-filter-bar.scss");
var api_constants_1 = require("./constants/api-constants");
var constants_1 = require("./constants/constants");
var GenericFunctions = require("./generic-functions");
var queryString = require('query-string');
var categories_menu_1 = require("./categories-menu");
var mobile_breadcrumb_1 = require("./mobile-breadcrumb");
var SubCategoriesFilterBar = /** @class */ (function () {
    function SubCategoriesFilterBar() {
    }
    SubCategoriesFilterBar.init = function () {
        if ($(SubCategoriesFilterBar.idSelector + " ul li").length > 0) {
            //visibility
            $(SubCategoriesFilterBar.idSelector + "").show();
            //events
            $(SubCategoriesFilterBar.idSelector + " .clt li a").off("click");
            $(SubCategoriesFilterBar.idSelector + " .clt li a .expand-subcategory").on("click", function (event) {
                var that = $(this);
                that.parents(".selected").removeClass("selected");
                var children = that.parent().siblings("ul");
                var options = {
                    complete: function () {
                        that.children().toggle();
                    }
                };
                $(children[0]).toggle(options);
                event.preventDefault();
                event.stopPropagation();
            });
            //check default subcategory
            SubCategoriesFilterBar.setCurrentCategories();
            SubCategoriesFilterBar.modalCloseWhenNoChildren();
        }
    };
    SubCategoriesFilterBar.isLoadNeeded = function () {
        var parsed = queryString.parse(location.search);
        var subCategoryId = parsed.SubCategoryId;
        return categories_menu_1.CategoriesMenu.currentCategory != SubCategoriesFilterBar.LastCategoryLoaded || subCategoryId != SubCategoriesFilterBar.CurrentSubcategory;
    };
    SubCategoriesFilterBar.load = function (memberNr) {
        var parsed = queryString.parse(location.search);
        var subCategoryId = parsed.SubCategoryId;
        if (categories_menu_1.CategoriesMenu.currentCategory != SubCategoriesFilterBar.LastCategoryLoaded) {
            SubCategoriesFilterBar.loadData(memberNr);
        }
        else if (subCategoryId != SubCategoriesFilterBar.CurrentSubcategory) {
            SubCategoriesFilterBar.setCurrentCategories();
        }
    };
    SubCategoriesFilterBar.setCurrentCategories = function () {
        //set default styles
        $(SubCategoriesFilterBar.idSelector + " .collapse").hide();
        $(SubCategoriesFilterBar.idSelector + " .expand").show();
        $(SubCategoriesFilterBar.idSelector + " ul:not(.tree-level-1)").hide();
        $(SubCategoriesFilterBar.idSelector + " li.selected").removeClass("selected");
        //current subcategory id
        var parsed = queryString.parse(location.search);
        var subCategoryId = parsed.SubCategoryId;
        SubCategoriesFilterBar.CurrentSubcategory = subCategoryId;
        SubCategoriesFilterBar.selectSubCategory(subCategoryId);
        SubCategoriesFilterBar.LastCategoryLoaded = categories_menu_1.CategoriesMenu.currentCategory;
    };
    SubCategoriesFilterBar.selectSubCategory = function (subcategoryId) {
        if (subcategoryId != undefined) {
            var $category = $(SubCategoriesFilterBar.idSelector + " li[data-subcategory-id=" + subcategoryId + "]");
            $category.addClass('selected');
            $category.parents("ul").show();
            $category.parents("li").children("a").children(".expand-subcategory").children(".expand").hide();
            $category.parents("li").children("a").children(".expand-subcategory").children(".collapse").show();
            //expand children
            var children = $category.children("ul");
            if (children.length > 0) {
                var child = $(children[0]);
                child.show();
                //expand children
                $category.children("a").children(".expand-subcategory").children(".expand").hide();
                $category.children("a").children(".expand-subcategory").children(".collapse").show();
            }
        }
    };
    SubCategoriesFilterBar.loadData = function (memberNr) {
        SubCategoriesFilterBar.setCurrentCategories();
        $(SubCategoriesFilterBar.idSelector + "").addClass("loading-content");
        var promise = $.get({
            url: window.BaseUrlWithVersions + "/" + api_constants_1.ApiConstants.ProductSearchBase + "/" + categories_menu_1.CategoriesMenu.currentCategory + "/" + api_constants_1.ApiConstants.ProductSearchSubCategories,
        });
        promise.done(function (data) {
            var callBack = function () {
                $(SubCategoriesFilterBar.idSelector + "").html(data);
                SubCategoriesFilterBar.init();
                SubCategoriesFilterBar.modalCloseWhenNoChildren();
                mobile_breadcrumb_1.MobileBreadcrumb.init();
            };
            GenericFunctions.ajaxResponseRedirectIfNeeded(data, callBack);
        });
        promise.fail(function () {
            GenericFunctions.showErrorMessage(constants_1.Constants.ErrorGettingCategories);
        });
        promise.always(function () {
            $(SubCategoriesFilterBar.idSelector + "").removeClass("loading-content");
        });
    };
    SubCategoriesFilterBar.modalCloseWhenNoChildren = function () {
        if (GenericFunctions.isMobile()) {
            $(SubCategoriesFilterBar.idSelector + " .clt li a").off("click");
            $(SubCategoriesFilterBar.idSelector + " .clt li a").on("click", function (e) {
                if ($(this).siblings().length == 0) {
                    clearTimeout(SubCategoriesFilterBar.timeoutCloseModal);
                    SubCategoriesFilterBar.timeoutCloseModal = setTimeout(function () {
                        GenericFunctions.handleClickCloseModal(e);
                    }, 500);
                }
            });
        }
    };
    SubCategoriesFilterBar.timeoutCloseModal = null;
    SubCategoriesFilterBar.idSelector = "#subcategories-filter-bar";
    return SubCategoriesFilterBar;
}());
exports.SubCategoriesFilterBar = SubCategoriesFilterBar;
